import React from 'react'
import { useTranslation } from 'react-i18next'

function Loading() {

  const { t } = useTranslation()

  return (
    <div
      className='fixed inset-0 z-[1050] flex items-center justify-center bg-slate-900/50'
      style={{ zIndex: 1050 }}
    >
      <div className='text-center'>
        <div className='mx-auto h-10 w-10 animate-spin rounded-full border-4 border-slate-300 border-t-white' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
        <h5 className='mt-3 text-base font-semibold text-white'>{t("Loading")}...</h5>
      </div>
    </div>
  )
}

export default Loading